/**
 * Walks a form's linked list of nodes starting from its START_FORM node and
 * returns them in connection order.
 */
export const sortFormNodes = (node, formNodes, newNodes = []) => {
    newNodes.push(node);
    const nextNodeId = node?.routes?.static?.next?.target;
    const next = formNodes?.find(i => i?.id === nextNodeId);
    if (next) {
        sortFormNodes(next, formNodes, newNodes);
    }
    return newNodes;
};
